import classNames from 'classnames'
import { HIGHLIGHT_METRIC, HighlightDetailResponse } from '../../../../model/caf.interface'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import { getMetric } from '../../../../modules/hooks/webview/caf/chart/utilFunction'
import findWordingKey from '../../../../modules/hooks/webview/caf/common/findWordingKey'
import useMapTagToWording from '../../../../modules/hooks/webview/caf/common/useMapTagToWording'
import { returnMetricItemInfo } from '../../../../modules/hooks/webview/caf/etc/useHighlightInfo'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { EMOJI_GOOD_BLACK, ICON_QUESTION_GRAY } from '../../../../modules/svg/svg'
import { COLORS } from '../../../../modules/vars'
import SpeechRateChart from '../charts/SpeechRateChart'
import Card from '../common/Card'
import HighlightedTitle from '../common/HighlightedTitle'
import { useWebviewModal } from '../common/Modal/WebviewModal'

const HighlightIntro = ({ data }: { data: HighlightDetailResponse }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const webViewPopup = useWebviewModal()
  const openPopup = () => {
    webViewPopup.show({
      id: 'hilight_popup',
      title: t(n_caf.highlight.select),
      body: t(findWordingKey(n_caf, { key: ['highlight', `modal_${getMetric(data.highlight_tag)}`] })),
    })
  }

  const hasDetailData = data.active
  const { countWordingPerTag } = useMapTagToWording(true)
  const count = () => {
    if (data.highlight_tag === 15 || data.highlight_tag === 16) return data.interval_count
    return data.count
  }
  const isMetricGrammar = getMetric(data.highlight_tag) === HIGHLIGHT_METRIC.GRAMMAR

  if (isMobile) {
    return (
      <Card clx="mb-[16px] bg-white">
        <>
          <HighlightedTitle
            color={hasDetailData ? COLORS.PURPLE50 : COLORS.GRAY200}
            title={
              hasDetailData
                ? countWordingPerTag(data.highlight_tag, count()).count
                : countWordingPerTag(data.highlight_tag).noCount
            }
          />
          <p
            className={classNames(
              isMetricGrammar && `mb-[16px]`,
              `mt-[4px] text-[12px] font-medium  capitalize text-gray-500`
            )}
          >
            {data.component}
          </p>
        </>
        {hasDetailData ? (
          <article className="text-h5 ">
            <h3 className="my-[12px]">{t(returnMetricItemInfo(getMetric(data.highlight_tag)).graph_title)}</h3>
            <CAFChart type={getMetric(data.highlight_tag)} data={data} />
          </article>
        ) : (
          <>
            <div className="text-h5 flex flex-col items-center justify-end rounded-[6px] bg-gray-50 p-[16px] text-center font-medium">
              <img src={EMOJI_GOOD_BLACK} className="mb-[18px]" alt="emoji" />
              {t(returnMetricItemInfo(getMetric(data.highlight_tag) as HIGHLIGHT_METRIC).skeleton_msg)}
            </div>
            <h3 className="my-[12px]">{t(returnMetricItemInfo(getMetric(data.highlight_tag)).graph_title)}</h3>
            <CAFChart type={getMetric(data.highlight_tag)} data={data} />
          </>
        )}
        {isMetricGrammar && (
          <div className="mt-[16px] flex  items-center text-sm text-gray-500" onClick={openPopup}>
            {t(n_caf.highlight.select)}
            <img src={ICON_QUESTION_GRAY} className="ml-[6px] mb-3 w-[14px]" alt="question" />
          </div>
        )}
      </Card>
    )
  } else {
    return (
      <Card clx="mb-[16px] bg-white max-w-[424px] w-[100%]">
        {hasDetailData ? (
          <article className="text-h5 ">
            <h3 className="my-[12px]">{t(returnMetricItemInfo(getMetric(data.highlight_tag)).graph_title)}</h3>
            <CAFChart type={getMetric(data.highlight_tag)} data={data} />
          </article>
        ) : (
          <>
            <div className="keep-all flex flex-col items-center justify-start rounded-[6px] px-[60px] text-center text-[14px] font-medium text-gray-500">
              <img src={EMOJI_GOOD_BLACK} className="mb-[16px]" alt="emoji" />
              {t(returnMetricItemInfo(getMetric(data.highlight_tag) as HIGHLIGHT_METRIC).skeleton_msg)}
            </div>
            {data.graph && (
              <h3 className="mt-[12px]">{t(returnMetricItemInfo(getMetric(data.highlight_tag)).graph_title)}</h3>
            )}
            <CAFChart type={getMetric(data.highlight_tag)} data={data} />
          </>
        )}
      </Card>
    )
  }
}
const CAFChart = ({ type, data }) => {
  const products = {
    [HIGHLIGHT_METRIC.SPEECH_RATE]: (
      <SpeechRateChart
        data={data.graph?.data}
        marker={true}
        dataKey={'wpm'}
        indexBy={'sentence'}
        options={{
          margin: {
            top: 12,
            left: 0,
            right: 5,
            bottom: 23,
          },
        }}
      />
    ),
  }
  return data.graph ? products[type] : null
}

export default HighlightIntro
